import { useState } from "react";
import type { BlockType } from "@/types";
import { Button } from "@/components/ui";
import { BLOCK_META, CORE_TYPES, EDITORIAL_TYPES } from "./defaults";

/** Add-block menu, grouped Core / Editorial (§4). Appends to the end. */
export function AddBlockMenu({ onAdd }: { onAdd: (type: BlockType) => void }) {
  const [open, setOpen] = useState(false);

  function pick(type: BlockType) {
    onAdd(type);
    setOpen(false);
  }

  return (
    <div className="add-block">
      <Button variant="primary" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        + Add block
      </Button>
      {open ? (
        <>
          <div className="add-block__scrim" onClick={() => setOpen(false)} />
          <div className="add-block__menu" role="menu">
            <Group title="Core" types={CORE_TYPES} onPick={pick} />
            <Group title="Editorial" types={EDITORIAL_TYPES} onPick={pick} />
          </div>
        </>
      ) : null}
    </div>
  );
}

function Group({
  title,
  types,
  onPick,
}: {
  title: string;
  types: BlockType[];
  onPick: (t: BlockType) => void;
}) {
  return (
    <div className="add-block__group">
      <p className="add-block__group-title">{title}</p>
      {types.map((t) => (
        <button key={t} type="button" className="add-block__item" role="menuitem" onClick={() => onPick(t)}>
          {BLOCK_META[t].label}
        </button>
      ))}
    </div>
  );
}
